const data: any = {
  func: { apiHost: "//joshome.jd.com", loginHost: "https://passport.jd.com/new/login.aspx" },
  style: {},
  data: {},
  _clstag_: "jdzeus_commontools_zeus_common_tools",
};
export default data;
